import React from "react";
import { Box, Link, Typography } from "@mui/material";
import GroupAllUsers from "../FieldTags/GroupAllUsers";

const FileLoadStatus = ({ fileLoadStatus }) => {
    let statusMessage = "Status code not found.";
    let boxStyles = {
        backgroundColor: "#BBDDFF",
        color: "#000040",
        padding: "16px",
        borderRadius: "4px",
        marginTop: "8px",
        width: "100%",
        display: "block"
    };

    if (fileLoadStatus === "A") {
        statusMessage = "Pull List successfully processed.";
        boxStyles = {
            backgroundColor: "#CCFFCC",
            color: "#1A563F",
            padding: "16px",
            borderRadius: "4px",
            marginTop: "8px",
            width: "100%",
            display: "block"
        };
    } else if (fileLoadStatus === "R") {
        statusMessage = (
            <>
                Pull List failed to process. Please ensure that you are using{" "}
                <Link href="https://bri.app.box.com/file/1550576158804" target="_blank" rel="noopener" style={{ textDecoration: "underline" }}>
                    an approved template
                </Link>
                .
            </>
        );
        boxStyles = {
            backgroundColor: "#FFD1D1",
            color: "#6B0036",
            padding: "16px",
            borderRadius: "4px",
            marginTop: "8px",
            width: "100%",
            display: "block"
        };
    } else if (fileLoadStatus === null || fileLoadStatus === undefined) {
        statusMessage = (
            <>
                Pull List not yet processed. Contact{" "}
                <Link href="mailto:dct@immunetolerance.org" style={{ textDecoration: "underline" }}>
                    dct@immunetolerance.org
                </Link>{" "}
                to expedite if necessary.
            </>
        );
    }

    return (
        <div className="planField">
            <div className="notVisible">
                <GroupAllUsers/>
            </div>
            <Box style={boxStyles}>
                <Typography component="span" style={{ fontWeight: "bold" }}>
                    Pull List Processing Status:
                </Typography>
                <Typography component="span" style={{ whiteSpace: "pre-line" }}>
                    {" \t"}{statusMessage}
                </Typography>
            </Box>
        </div>
    );
};

export default FileLoadStatus;